import React from 'react';

export default function useFooterInView() {
  const [isFooterInView, setIsFooterInView] = React.useState(false);

  React.useEffect(() => {
    const footerElement = document.getElementById('page-footer');

    if (!footerElement) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFooterInView(entry.isIntersecting);
      },
      {
        threshold: 0.1, // Trigger when 10% of footer is visible
        rootMargin: '0px 0px -50px 0px', // Start hiding slightly before footer is fully visible
      },
    );

    observer.observe(footerElement);

    return () => {
      observer.disconnect();
    };
  }, []);

  return isFooterInView;
}
